"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressSchema = void 0;
var suretype_1 = require("suretype");
exports.addressSchema = suretype_1.v.object({
    city: suretype_1.v.string().required(),
    country: suretype_1.v.string().required(),
    line1: suretype_1.v.string().required(),
    line2: suretype_1.v.anyOf([suretype_1.v.string(), suretype_1.v.null()]).required(),
    postal_code: suretype_1.v.string().required(),
    state: suretype_1.v.string().required(),
});
